import { render, staticRenderFns } from "./AlertSubscriptionButton.vue?vue&type=template&id=08c0ca5f&scoped=true&"
import script from "./AlertSubscriptionButton.vue?vue&type=script&lang=ts&"
export * from "./AlertSubscriptionButton.vue?vue&type=script&lang=ts&"
import style0 from "./AlertSubscriptionButton.vue?vue&type=style&index=0&id=08c0ca5f&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08c0ca5f",
  null
  
)

export default component.exports